// extracted by mini-css-extract-plugin
export var avatarContainer = "_40-0";
export var gray = "_40-f";
export var green = "_40-c";
export var icon = "_40-9";
export var image = "_40-1";
export var lg = "_40-6";
export var md = "_40-5";
export var presenceDot = "_40-b";
export var red = "_40-d";
export var sm = "_40-4";
export var status = "_40-a";
export var xl = "_40-7";
export var xs = "_40-3";
export var xxl = "_40-8";
export var xxs = "_40-2";
export var yellow = "_40-e";